/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Dialogue_List_AriaInputs */

const en_file_export_dialogue_list_aria = /** @type {(inputs: File_Export_Dialogue_List_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export dialogue list`)
};

const fr_file_export_dialogue_list_aria = /** @type {(inputs: File_Export_Dialogue_List_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter la liste des dialogues`)
};

const de_file_export_dialogue_list_aria = /** @type {(inputs: File_Export_Dialogue_List_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialogliste exportieren`)
};

const it_file_export_dialogue_list_aria = /** @type {(inputs: File_Export_Dialogue_List_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta elenco dialoghi`)
};

const ru_file_export_dialogue_list_aria = /** @type {(inputs: File_Export_Dialogue_List_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт списка диалогов`)
};

const es_file_export_dialogue_list_aria = /** @type {(inputs: File_Export_Dialogue_List_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista de diálogo de exportación`)
};

const zh_cn2_file_export_dialogue_list_aria = /** @type {(inputs: File_Export_Dialogue_List_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出对话框列表`)
};

const ja_file_export_dialogue_list_aria = /** @type {(inputs: File_Export_Dialogue_List_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ダイアログリストをエクスポート`)
};

const hi_file_export_dialogue_list_aria = /** @type {(inputs: File_Export_Dialogue_List_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात संवाद सूची`)
};

const pt_pt2_file_export_dialogue_list_aria = /** @type {(inputs: File_Export_Dialogue_List_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista de diálogo de exportação`)
};

/**
* | output |
* | --- |
* | "Export dialogue list" |
*
* @param {File_Export_Dialogue_List_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_dialogue_list_aria = /** @type {((inputs?: File_Export_Dialogue_List_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Dialogue_List_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_export_dialogue_list_aria(inputs)
	if (locale === "de") return de_file_export_dialogue_list_aria(inputs)
	if (locale === "it") return it_file_export_dialogue_list_aria(inputs)
	if (locale === "ru") return ru_file_export_dialogue_list_aria(inputs)
	if (locale === "es") return es_file_export_dialogue_list_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_file_export_dialogue_list_aria(inputs)
	if (locale === "ja") return ja_file_export_dialogue_list_aria(inputs)
	if (locale === "hi") return hi_file_export_dialogue_list_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_file_export_dialogue_list_aria(inputs)
	return en_file_export_dialogue_list_aria(inputs)
});